const initialState = {
  eventos: [],
  destinatarios: [],
  loading: false,
  error: null
};

const adminReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_EVENTOS_REQUEST':
    case 'FETCH_DESTINATARIOS_REQUEST':
    case 'CREATE_EVENTO_REQUEST':
    case 'CREATE_DESTINATARIO_REQUEST':
    case 'VINCULAR_DESTINATARIO_REQUEST':
    case 'DESVINCULAR_DESTINATARIO_REQUEST':
    case 'TOGGLE_DESTINATARIO_ACTIVO_REQUEST':
    case 'SET_DESTINATARIO_PRINCIPAL_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_EVENTOS_SUCCESS':
      return { ...state, loading: false, eventos: action.payload };
    case 'FETCH_DESTINATARIOS_SUCCESS':
      return { ...state, loading: false, destinatarios: action.payload };
    case 'CREATE_EVENTO_SUCCESS':
    case 'CREATE_DESTINATARIO_SUCCESS':
    case 'VINCULAR_DESTINATARIO_SUCCESS':
    case 'DESVINCULAR_DESTINATARIO_SUCCESS':
    case 'TOGGLE_DESTINATARIO_ACTIVO_SUCCESS':
    case 'SET_DESTINATARIO_PRINCIPAL_SUCCESS':
      return { ...state, loading: false };
    case 'FETCH_EVENTOS_FAIL':
    case 'FETCH_DESTINATARIOS_FAIL':
    case 'CREATE_EVENTO_FAIL':
    case 'CREATE_DESTINATARIO_FAIL':
    case 'VINCULAR_DESTINATARIO_FAIL':
    case 'DESVINCULAR_DESTINATARIO_FAIL':
    case 'TOGGLE_DESTINATARIO_ACTIVO_FAIL':
    case 'SET_DESTINATARIO_PRINCIPAL_FAIL':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default adminReducer;
